import React from 'react'
import { ReactComponent as CrossIcon } from 'icons/cross-16.svg'
import { ChildrenWrapper, CloseWrapper, Wrapper } from './Toast.styles'
import { HoverableProps } from 'react-event-as-prop'
import { Variant } from './Toast.types'

const testIds = {
  default: 'toast-default',
  negative: 'toast-negative',
  positive: 'toast-positive',
}

export interface ToastProps extends HoverableProps {
  id: string
  children: React.ReactNode
  variant: Variant
  onClose: () => void
}

export const Toast = ({
  children,
  id,
  variant,
  onClose,
  ...props
}: ToastProps) => {
  return (
    <Wrapper
      id={id}
      data-testid={testIds[variant]}
      variant={variant}
      {...props}>
      <ChildrenWrapper>{children}</ChildrenWrapper>
      <CloseWrapper onClick={onClose}>
        <CrossIcon width={16} height={16} />
      </CloseWrapper>
    </Wrapper>
  )
}
